export default function SectionTitle({ title }: { title: string }) {
  return (
    <h2 className='mb-8 block border-b-4 text-[#B2B2B2] border-brand pb-2 text-xl uppercase md:text-3xl'>
      {title}
    </h2>
  );
}
